import {atom} from "jotai";

export const settingsDialogStateAtom = atom(false);